import { render } from "./RequestRejectPage.vue?vue&type=template&id=be9853d4&ts=true"
import script from "./RequestRejectPage.vue?vue&type=script&lang=ts"
export * from "./RequestRejectPage.vue?vue&type=script&lang=ts"

import "./RequestRejectPage.vue?vue&type=style&index=0&id=be9853d4&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__